import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
};

export type _Service = {
   __typename?: '_Service',
  sdl: Scalars['String'],
};

export type AuthHandle = {
   __typename?: 'AuthHandle',
  status: AuthStatus,
  session: SessionHandle,
};

export enum AuthStatus {
  Ready = 'Ready',
  Requires2Fa = 'Requires2FA',
  Anonymous = 'Anonymous'
}

export type CreateModalData = {
   __typename?: 'CreateModalData',
  type?: Maybe<Scalars['String']>,
  accountId?: Maybe<Scalars['String']>,
  accountName?: Maybe<Scalars['String']>,
  companyId?: Maybe<Scalars['Int']>,
  companyName?: Maybe<Scalars['String']>,
};

export type CreateModalDataInput = {
  type?: Maybe<Scalars['String']>,
  accountId?: Maybe<Scalars['String']>,
  accountName?: Maybe<Scalars['String']>,
  companyId?: Maybe<Scalars['Int']>,
  companyName?: Maybe<Scalars['String']>,
};

export type Mutation = {
   __typename?: 'Mutation',
  appendError?: Maybe<Scalars['Int']>,
  clearErrors?: Maybe<Scalars['Int']>,
  closeCreateModal?: Maybe<Scalars['Int']>,
  closeCreateOpportunity?: Maybe<Scalars['Int']>,
  forgotPassword: Scalars['Boolean'],
  login: AuthHandle,
  openCreateModal?: Maybe<Scalars['Int']>,
  openCreateOpportunity?: Maybe<Scalars['Int']>,
  partialDetailsSignup: AuthHandle,
  release: AuthHandle,
  requestAuthLink: Scalars['Boolean'],
  requestTwoFactorSMS: Scalars['Boolean'],
  resetPasswordFromToken: AuthHandle,
  signup: AuthHandle,
};


export type MutationAppendErrorArgs = {
  errorMsg: Scalars['String']
};


export type MutationClearErrorsArgs = {
  errorMsg?: Maybe<Scalars['String']>
};


export type MutationCloseCreateModalArgs = {
  id?: Maybe<Scalars['String']>
};


export type MutationCloseCreateOpportunityArgs = {
  id?: Maybe<Scalars['String']>
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']
};


export type MutationLoginArgs = {
  email: Scalars['String'],
  password: Scalars['String'],
  twofa?: Maybe<Scalars['String']>
};


export type MutationOpenCreateModalArgs = {
  data: CreateModalDataInput
};


export type MutationOpenCreateOpportunityArgs = {
  accountId?: Maybe<Scalars['String']>,
  accountName?: Maybe<Scalars['String']>
};


export type MutationPartialDetailsSignupArgs = {
  from: PartialDetailsSignupFormInput
};


export type MutationRequestAuthLinkArgs = {
  email: Scalars['String'],
  redirectTo: Scalars['String']
};


export type MutationRequestTwoFactorSmsArgs = {
  email: Scalars['String']
};


export type MutationResetPasswordFromTokenArgs = {
  email: Scalars['String'],
  newPassword: Scalars['String'],
  resetToken: Scalars['String']
};


export type MutationSignupArgs = {
  from: UserDetailsInput
};

export type PartialDetailsSignupFormInput = {
  email: Scalars['String'],
  flowType?: Maybe<Scalars['String']>,
  holdingCompanyId?: Maybe<Scalars['Int']>,
  equityValue?: Maybe<Scalars['String']>,
};

export type Query = {
   __typename?: 'Query',
  _fieldSet: Scalars['String'],
  _service: _Service,
  create_modal_data?: Maybe<CreateModalData>,
  create_opportunity_account_id?: Maybe<Scalars['String']>,
  create_opportunity_name?: Maybe<Scalars['String']>,
  errors?: Maybe<Array<Scalars['String']>>,
  is_create_modal_open?: Maybe<Scalars['Boolean']>,
  is_create_opportunity_open?: Maybe<Scalars['Boolean']>,
  userId?: Maybe<Scalars['Int']>,
};

export type SessionHandle = {
   __typename?: 'SessionHandle',
  key: Scalars['String'],
  value: Scalars['String'],
};

export type UserDetailsInput = {
  email: Scalars['String'],
  first_name: Scalars['String'],
  last_name: Scalars['String'],
  phone_country_code?: Maybe<Scalars['Int']>,
  phone_number?: Maybe<Scalars['String']>,
  password: Scalars['String'],
  utm?: Maybe<UtmInfoInput>,
  accepted_tos_pp: Scalars['Boolean'],
};

export type UtmInfoInput = {
  source?: Maybe<Scalars['String']>,
  medium?: Maybe<Scalars['String']>,
  campaign?: Maybe<Scalars['String']>,
  term?: Maybe<Scalars['String']>,
  content?: Maybe<Scalars['String']>,
};

export type LogoutMutationVariables = {};


export type LogoutMutation = (
  { __typename?: 'Mutation' }
  & { release: (
    { __typename?: 'AuthHandle' }
    & Pick<AuthHandle, 'status'>
  ) }
);


export const LogoutDocument = gql`
    mutation Logout {
  release {
    status
  }
}
    `;
export type LogoutMutationFn = ApolloReactCommon.MutationFunction<LogoutMutation, LogoutMutationVariables>;
export type LogoutComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<LogoutMutation, LogoutMutationVariables>, 'mutation'>;

    export const LogoutComponent = (props: LogoutComponentProps) => (
      <ApolloReactComponents.Mutation<LogoutMutation, LogoutMutationVariables> mutation={LogoutDocument} {...props} />
    );
    
export type LogoutProps<TChildProps = {}> = ApolloReactHoc.MutateProps<LogoutMutation, LogoutMutationVariables> & TChildProps;
export function withLogout<TProps, TChildProps = {}>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  LogoutMutation,
  LogoutMutationVariables,
  LogoutProps<TChildProps>>) {
    return ApolloReactHoc.withMutation<TProps, LogoutMutation, LogoutMutationVariables, LogoutProps<TChildProps>>(LogoutDocument, {
      alias: 'logout',
      ...operationOptions
    });
};

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        return ApolloReactHooks.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, baseOptions);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = ApolloReactCommon.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = ApolloReactCommon.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;